export default "__VITE_ASSET__$6v9bJJZ__"